import { styled } from '@mui/system';
import { List, Button, ListItemButton } from '@mui/material';

const DrawerItem = styled(ListItemButton)(({ theme }) => ({
  color: theme.palette.text.primary,
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'rgb(233, 236, 239)',
    borderRadius: '0px 24px 24px 0px',
    position: 'relative',
    '&::before': {
      left: 0,
      top: 0,
      content: '""',
      position: 'absolute',
      display: 'inline-block',
      width: 4,
      height: '100%',
      backgroundColor: 'rgba(173, 181, 189)',
    },
  },
}));

const SelectedItem = styled(DrawerItem)(({ theme }) => ({
  backgroundColor: 'rgba(115, 82, 199, 0.15)',
  borderRadius: '0px 24px 24px 0px',
  position: 'relative',
  '&::before': {
    left: 0,
    top: 0,
    content: '""',
    position: 'absolute',
    display: 'inline-block',
    width: 4,
    height: '100%',
    backgroundColor: 'rgb(115, 82, 199)',
  },
}));

const ScrollableList = styled(List)({
  overflowY: 'auto',
  flexGrow: 1,
});

const BottomSection = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: '16px',
});

const UserName = styled('div')(({ theme }) => ({
  fontWeight: 'bold',
}));

const LogoutButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  color: theme.palette.error.main,
}));

export { DrawerItem, SelectedItem, ScrollableList, BottomSection, UserName, LogoutButton };
